exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alerta {\n  position: absolute;\n  top: 83px;\n  right: 4px;\n  z-index: 10; }\n\n.alert-cinza {\n  background-color: #707070;\n  border-color: #d0e9c6;\n  color: #d7d7d7; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/alerta-notificacao/alerta-notificacao.component.scss
// module id = ../../../../../src/app/angular-base-ui/alerta-notificacao/alerta-notificacao.component.scss
// module chunks = 1